// extracted by mini-css-extract-plugin
export default {"main":"layout_main__Mho7F","wrapper":"layout_wrapper__yw5Pz"};